import { EventLogApiModel } from '../../../types/models/event-log.model';
import { GetEventLogApiRequest } from '../../../types/requests/event-logs/get-event-log.request';
import { SearchEventLogsApiRequest } from '../../../types/requests/event-logs/search-event-logs.request';
import { CursorPaginatedApiResponse } from '../../../types/responses/cursor-paginated.response';
import { client } from './client';

export const getEventLog = <T extends EventLogApiModel>({ eventLogId, ...params }: GetEventLogApiRequest) =>
  client.get<T>(`/event-logs/${eventLogId}`, { params });

export const searchEventLogs = (params: SearchEventLogsApiRequest) =>
  client.get<CursorPaginatedApiResponse<EventLogApiModel>>(`/event-logs`, { params });
